// Le nom de fichier d'un drapeau n'est jamais son code ISO en clair : ça
// permettrait de trouver la réponse d'un simple "Inspecter l'élément" sur
// l'image affichée. On dérive un slug stable par un hash (FNV-1a + sel),
// recalculé côté build pour renommer les SVG (voir scripts/rename-flags.mjs).
//
// Changer le sel renomme les 193 fichiers d'un coup : c'est le seul moyen de
// garantir un vrai cache miss quand le CONTENU d'un drapeau change sous le
// même code pays (ex. changement de régime — la Syrie fin 2024), puisque
// nginx sert ces SVG en `immutable`. Passé de v1 à v2 pour cette raison.
const FLAG_SALT = "geonerd-flag-v2";

export function getFlagSlug(code) {
    const input = FLAG_SALT + code.toLowerCase();
    let hash = 2166136261;
    for (let i = 0; i < input.length; i++) {
        hash ^= input.charCodeAt(i);
        hash = Math.imul(hash, 16777619);
    }
    return (hash >>> 0).toString(36);
}

export function getFlagPath(code) {
    return `/img/flags/${getFlagSlug(code)}.svg`;
}

/**
 * Error-recap item for every QCM game where a wrong click still names a real
 * country (Flag Nerd Classic/Tricky/Speed Run, Capital Nerd Reverse, Map Nerd
 * Classic, Daily Challenge classic): the guessed flag on the left (red
 * border, name struck through) and the correct flag on the right (green
 * border, name in green). `context` is an optional caption shown above the
 * duel for games whose question isn't itself a flag (e.g. the capital shown
 * in Capital Nerd Reverse).
 */
export function renderFlagDuelError(error, context = "") {
    const guessed = window.geoNerdApp.countries.find(c => c.code === error.guessedCode);
    const contextHtml = context ? `<div class="error-country">${context}</div>` : "";

    return `
        <div class="error-item">
            ${contextHtml}
            <div class="flags-duel">
                <div class="error-flag wrong">
                    <img src="${getFlagPath(error.guessedCode)}" alt="${guessed.name}">
                    <div class="error-answer-text wrong">${guessed.name}</div>
                </div>
                <div class="error-flag correct">
                    <img src="${getFlagPath(error.correctCode)}" alt="${error.countryName}">
                    <div class="error-answer-text correct">${error.countryName}</div>
                </div>
            </div>
        </div>
    `;
}
